export interface AddressData {
	title: string;
	firstName: string;
	lastName: string;
	companyName: string;
}

export interface FormattedAddress {
	firstLine: string;
	secondLine: string | null;
}

/**
 * Formats address lines based on whether the recipient is a company or natural person
 * @param isCompany - Whether the recipient is a company
 * @param addressData - The address data containing names and company info
 * @returns Formatted address with first and second lines
 */
export function formatAddressLines(
	isCompany: boolean,
	addressData: AddressData
): FormattedAddress {
	let firstLine: string;
	let secondLine: string | null = null;

	// Trim whitespace to check for actual content
	const hasCompanyName = addressData.companyName && addressData.companyName.trim();

	if (isCompany) {
		if (hasCompanyName) {
			firstLine = addressData.companyName;
			secondLine = null;
		} else {
			// Fallback for missing company name
			firstLine = addressData.title;
			const nameParts: string[] = [];
			if (addressData.firstName) nameParts.push(addressData.firstName);
			if (addressData.lastName) nameParts.push(addressData.lastName);
			secondLine = nameParts.length > 0 ? nameParts.join(" ") : null;
		}
	} else {
		// Natural person
		if (hasCompanyName) {
			// Optional company name for natural person
			firstLine = addressData.companyName;
			const nameParts: string[] = [];
			if (addressData.title) nameParts.push(addressData.title);
			if (addressData.firstName) nameParts.push(addressData.firstName);
			if (addressData.lastName) nameParts.push(addressData.lastName);
			secondLine = nameParts.length > 0 ? nameParts.join(" ") : null;
		} else {
			firstLine = addressData.title;
			const nameParts: string[] = [];
			if (addressData.firstName) nameParts.push(addressData.firstName);
			if (addressData.lastName) nameParts.push(addressData.lastName);
			secondLine = nameParts.length > 0 ? nameParts.join(" ") : null;
		}
	}

	return {
		firstLine,
		secondLine
	};
}